import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.createCalculation.title',
    defaultMessage: 'Create new calculation',
    description: 'title of the create calculation page',
  },
  feedback: {
    calculationNotCreated: {
      id: 'pages.createCalculation.feedback.calculationNotCreated',
      defaultMessage: 'Calculation could not be created',
      description: 'Calculation created error message',
    },
  },
};

export default defineMessages(translations);
